import { useState, useEffect } from 'react';
import { apiFetch, buildQueryString } from '../lib/api';
import type { GoogleKPIs, GoogleCampaign, TimeseriesPoint } from '../types';

interface Filters {
  startDate: string;
  endDate: string;
  service: string;
}

interface GoogleAdsData {
  kpis: GoogleKPIs | null;
  timeseries: TimeseriesPoint[];
  campaigns: GoogleCampaign[];
  isLoading: boolean;
  error: string | null;
}

export function useGoogleAdsData(filters: Filters): GoogleAdsData {
  const [kpis, setKpis] = useState<GoogleKPIs | null>(null);
  const [timeseries, setTimeseries] = useState<TimeseriesPoint[]>([]);
  const [campaigns, setCampaigns] = useState<GoogleCampaign[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setIsLoading(true);
    setError(null);

    const qs = buildQueryString({
      startDate: filters.startDate,
      endDate: filters.endDate,
      service: filters.service !== 'all' ? filters.service : undefined,
    });

    Promise.all([
      apiFetch<GoogleKPIs>(`/api/metrics/google-kpis${qs}`),
      apiFetch<TimeseriesPoint[]>(`/api/metrics/timeseries${qs}`),
      apiFetch<GoogleCampaign[]>(`/api/metrics/google-campaigns${qs}`),
    ]).then(([k, t, c]) => {
      setKpis(k);
      setTimeseries(t);
      setCampaigns(c);
    }).catch(err => {
      setError(err instanceof Error ? err.message : 'Erro ao carregar dados');
    }).finally(() => {
      setIsLoading(false);
    });
  }, [filters.startDate, filters.endDate, filters.service]);

  return { kpis, timeseries, campaigns, isLoading, error };
}
